const decodeJwt = (token) => {
  try {
    const payload = token.split(".")[1];
    return JSON.parse(atob(payload));
  } catch {
    return null;
  }
};

const checkAuthz = (token, groups) => {
  if (!token) {
    return false;
  }
  if (!groups.length) {
    return true;
  }
  const decoded = decodeJwt(token);
  if (!decoded?.user?.groups) {
    return false;
  }
  const intersection = decoded.user.groups.filter((groupName) =>
    groups.includes(groupName)
  );
  return !!intersection.length;
};
export default checkAuthz;
